import { Component } from '@angular/core';

@Component({
    selector: 'app-public-pages-layout',
    templateUrl: './public-pages-layout.component.html',
    standalone: false
})
export class PublicPagesLayoutComponent { 

}
